
export const FETCHING_CROP_YIELD_EVOLUTION= 'fetching:crop-yield-evolution';
export const FETCH_CROP_YIELD_EVOLUTION = 'fetch:crop-yield-evolution';
export const FETCH_CROP_FAILURE = 'fetch-crop-failure';
export const CLEANUP = 'cleanup';
